import Icon from '../components/Icon.vue'

Icon.register({
  spa: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M568.3 192C539.2 192.1 433.2 198.2 354.4 275 321.3 304.6 301.1 338.3 288 369.9 274.9 338.3 254.7 304.6 221.6 275 142.8 198.2 36.8 192.1 7.8 192 3.3 192 0 195.4 0 199.8 0.2 227.7 7.1 326 88.8 399.1 172.8 480.9 256 480 288 480S403.2 480.9 487.2 399.1C568.9 325.9 575.8 227.7 576 199.8 576 195.4 572.7 192 568.3 192zM288 302.6C300.8 283.8 315.6 266.8 332.1 252.1 351.2 233.5 371.7 218.8 392.3 206.9 375.9 136.4 340.6 73.9 295.6 34.7 291.5 31.1 284.6 31.1 280.5 34.7 235.5 73.8 200.2 136.3 183.7 206.8 204.1 218.4 224.2 232.9 242.9 251.1A282.8-282.8 0 0 0 288 302.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/spa.js
// module id = iN8u
// module chunks = 144